import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { LeadFormComponent } from './components/lead-form/lead-form.component';
import { IbanComponent } from './components/iban/iban.component';
import { AccountConversionFormComponent } from './components/account-conversion-form/account-conversion-form.component';
import { SupportingDocAccountConversionFormComponent } from './components/account-conversion-form/supporting-doc-account-conversion-form.component';
import { PoaFormComponent } from './components/poa-form/poa-form.component';
import { PoaDocComponent } from './components/poa-form/poa-doc.component';
import { TaxFormComponent } from './components/tax-form/tax-form.component';

export const appRoutes: Routes = [
  {
    path: 'error', component: ErrorPageComponent,
  },
  {
    path: 'products/:id',
    component: LeadFormComponent
  },
  {
    path: 'products/O/D',
    component: LeadFormComponent
  },
  {
    path: 'iban',
    component: IbanComponent
  },
  {
    path: 'CN1',
    component: AccountConversionFormComponent
  },
  {
    path: 'step2',
    component: SupportingDocAccountConversionFormComponent   
  },
  {
    path: 'POA',
    component: PoaFormComponent
  },
  {
    path: 'poa-doc',
    component: PoaDocComponent
  },
  {
    path:'taxInfo',
    component: TaxFormComponent

  },
  
  { path: '', pathMatch: 'full', redirectTo: 'iban' }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
export const routedComponents: any = [];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/app.route.ts